import React from "react";
import { teams } from "../assets/features";
import CardTeam from "../components/CardTeam";
import Carousel from "../components/Carousel";

const About = () => {
  return (
    <div className="flex flex-col items-center bg-primary">
      <h1 className="md:text-4xl text-2xl font-bold text-white ">About us</h1>
      <div className="flex md:flex-row flex-col items-center justify-center gap-5 p-12">
        <p className="text-white text-center md:w-[30%]">
          Our personal journeys, shaped by experiences in disadvantaged
          environments, have fueled a profound determination to drive change. As
          students in the mountains of North Africa, we keenly felt the barriers
          to education—inequalities and poverty. As foreign students in France,
          we witnessed the widespread nature of these challenges.
        </p>
        <img src="/images/pc.png" alt="produit" className="md:w-[40%]" />
        <p className="text-white text-center md:w-[30%]">
          {" "}
          With Studycool, we confront educational inequality head-on. Our
          platform aims to make education accessible to all by leveraging
          blockchain technology and innovative reward systems. We've made
          significant progress, conducting thorough market research and
          collaborating with experts to refine our solution. Showcasing our MVP
          at events like the Paris Blockchain Week, where we achieved 2nd place,
          has provided invaluable feedback. Our commitment to iterative
          development and user-centric design drives us to create a solution
          that truly addresses educational inequality.
        </p>
      </div>
      <div className="bg-white w-full flex flex-col gap-2 p-2">
        <h1 className="md:text-4xl text-2xl font-bold text-primary text-center mt-4">
          Our Journey
        </h1>
        <Carousel />
      </div>
      <h1 className="md:text-4xl text-2xl font-bold text-white mt-4">
        Notre équipe
      </h1>
      <div className="grid grid-cols-1  md:grid-cols-2 gap-6 my-12">
        {teams.map((why, i) => (
          <CardTeam member={why} key={i} />
        ))}
      </div>
      {/* <img
        loading="lazy"
        src="/images/down2.svg"
        className="w-full bg-secondary"
        alt="waves"
      /> */}
    </div>
  );
};

export default About;
